"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
 Reject previously started tasks once a new task is started.
 This ensures that only the most recently started task is considered, regardless
 of the order the tasks finish in.
 */
var rejectStaleTasks = function rejectStaleTasks(task) {
  var taskCount = 0;
  return function () {
    for (var _len = arguments.length, taskArguments = new Array(_len), _key = 0; _key < _len; _key++) {
      taskArguments[_key] = arguments[_key];
    }
    var thisTaskNumber = taskCount + 1;
    taskCount += 1;
    return new Promise(function (resolve, reject) {
      task.apply(void 0, taskArguments).then(function (data) {
        if (thisTaskNumber === taskCount) {
          resolve(data);
        } else {
          reject('stale');
        }
      })["catch"](function (error) {
        return reject(error);
      });
    });
  };
};
var _default = rejectStaleTasks;
exports["default"] = _default;